import React, { useCallback, useState } from 'react';

import { useIntl } from 'react-intl-next';

import ShowMoreIcon from '@atlaskit/icon/core/migration/show-more-horizontal--more';
import { MenuGroup } from '@atlaskit/menu';
import type { PopupProps } from '@atlaskit/popup';
import Tooltip from '@atlaskit/tooltip';

import { ToolbarButton } from '../toolbar-button';

import { messages } from './messages';

type Props = {
	buttonRef: React.RefObject<HTMLButtonElement | null>;
	hiddenButtons: JSX.Element[] | undefined;
};

const ShowMoreButton = ({ hiddenButtons, buttonRef }: Props): React.JSX.Element | null => {
	const [isOpen, setIsOpen] = useState(false);
	const { formatMessage } = useIntl();

	const onClick = () => setIsOpen((prev) => !prev);
	const onClose = () => setIsOpen(false);

	const moreButtonContent: PopupProps['content'] = useCallback(() => {
		return <MenuGroup>{hiddenButtons}</MenuGroup>;
	}, [hiddenButtons]);

	if (!hiddenButtons) {
		return null;
	}

	if (hiddenButtons.length > 0) {
		return (
			<Tooltip
				content={formatMessage(messages.moreButtonName)}
				ignoreTooltipPointerEvents
				hideTooltipOnClick
				hideTooltipOnMouseDown
				isScreenReaderAnnouncementDisabled
				position="right"
			>
				<ToolbarButton
					tabIndex={-1}
					buttonRef={buttonRef}
					action={{
						icon: ShowMoreIcon,
						name: formatMessage(messages.moreButtonName),
						type: 'popup',
						role: 'menu',
						iconOnly: true,
						isOpen,
						onClick,
						onClose,
						content: moreButtonContent,
					}}
				/>
			</Tooltip>
		);
	}

	return null;
};

export default ShowMoreButton;
